export default function filterData(tempObject, tempORows, columns) {
  let criteriaArray = {};
  let typeObject = {};
  let conditionObject = {};
  Object.keys(tempObject).map((key) => {
    let column = columns.filter((obj) => {
      return obj["id"] === key;
    });
    if (column && column.length > 0) {
      typeObject[key] = column[0].filterType;

      if (
        tempObject[key] &&
        Array.isArray(tempObject[key]) &&
        tempObject[key].length > 0
      ) {
        criteriaArray[key] = tempObject[key];
      } else if (
        tempObject[key] &&
        !Array.isArray(tempObject[key]) &&
        tempObject[key] !== ""
      ) {
        if (column[0].filterType === "date") {
          criteriaArray[key] = [new Date(tempObject[key])];
          conditionObject[key] = tempObject[key + "__condition"] || "lte";
        } else if (column[0].filterType === "number") {
          criteriaArray[key] = [tempObject[key]];
          conditionObject[key] = tempObject[key + "__condition"] || "lte";
        } else {
          criteriaArray[key] = [tempObject[key]];
        }
      }
    }
  });
  let filter = tempORows.filter((obj) =>
    Object.entries(criteriaArray).every(([prop, find]) => {
      if (typeObject[prop] === "date" && conditionObject[prop] === "lte") {
        if (obj[prop]) {
          return new Date(obj[prop]).getTime() < new Date(find).getTime();
        }
      } else if (
        typeObject[prop] === "date" &&
        conditionObject[prop] === "gte"
      ) {
        if (obj[prop]) {
          return new Date(obj[prop]).getTime() > new Date(find).getTime();
        }
      } else if (
        typeObject[prop] === "number" &&
        conditionObject[prop] === "gte"
      ) {
        if (obj[prop] >= 0) {
          return obj[prop] > find;
        }
      } else if (
        typeObject[prop] === "number" &&
        conditionObject[prop] === "lte"
      ) {
        if (obj[prop] >= 0) {
          return obj[prop] < find;
        }
      } else {
        return find.includes(obj[prop]);
      }
    })
  );
  return filter;
}
